import { dispatchGlobalError } from '../context/ApiErrorContext';
import { dispatchLogout } from '../context/AuthContext';
import { ProfileOption } from '../types/profile';
import { Usuario, usuarioPorId } from './usuarioService';

export const retornarPerfisUsuario = (usuario: Usuario): ProfileOption[] => {
  const perfis: ProfileOption[] = [];
  if (usuario.atleta?.id) {
    perfis.push({
      tipo: 'ATLETA',
      referenciaId: usuario.atleta.id,
      nome: usuario.nome,
      imagemUrl: usuario.imagemUrl ?? undefined,
    });
  }

  if (usuario.organizadores) {
    usuario.organizadores
      .filter((organizador) => organizador?.liga?.id)
      .forEach((organizador) => {
        perfis.push({
          tipo: 'LIGA',
          referenciaId: organizador.liga!.id,
          nome: organizador.liga!.nome,
          imagemUrl: organizador.liga!.imagemUrl ?? undefined,
        });
      });
  } 

  return perfis;
};

export const buscarPerfisDoUsuario = async (usuarioId: string): Promise<ProfileOption[]> => {
  try {
    const usuario = await usuarioPorId(usuarioId);
    if (!usuario) {
      return [];
    }

    const perfis: ProfileOption[] = [];

    if (usuario.atleta?.id) {
      perfis.push({
        tipo: 'ATLETA',
        referenciaId: usuario.atleta.id,
        nome: usuario.nome,
        imagemUrl: usuario.imagemUrl ?? undefined,
      });
    }

    if (usuario.organizadores) {
      usuario.organizadores
        .filter((organizador) => organizador?.liga?.id)
        .forEach((organizador) => {
          perfis.push({
            tipo: 'LIGA',
            referenciaId: organizador.liga!.id,
            nome: organizador.liga!.nome,
            imagemUrl: organizador.liga!.imagemUrl ?? undefined,
          });
        });
    }
    

    return perfis;
  } catch (error: any) {
    if (error.graphQLErrors) {
      const graphQLError = error.graphQLErrors[0];
      if (graphQLError?.extensions?.code === 'UNAUTHENTICATED') {
        dispatchLogout();
        if (typeof window !== 'undefined') {
          window.location.href = '/login';
        }
        throw error;
      }
    }

    if (error.response?.status === 401) {
      dispatchLogout();
      if (typeof window !== 'undefined') {
        window.location.href = '/login';
      }
      throw error;
    }

    let message = 'Erro ao buscar perfis do usuário. Tente novamente.';
    if (error.message) {
      message = error.message;
    }
    dispatchGlobalError(message);
    throw error;
  }
};

